// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31265":"6bceaa45","88801":"188db1b2"}[chunkId] + ".chunk.js";
};